/**
 * Normalise tunnelData.finalPageConfiguration : drapeaux booléens (défaut false),
 * avec prise en charge de l'ancien format finalPageForm: string[].
 */
export function normalizeFinalPageConfiguration(raw) {
  const r = raw && typeof raw === "object" ? raw : {}
  const legacy = Array.isArray(r.finalPageForm) ? r.finalPageForm : null

  const boolFromNewOrLegacy = (key, legacyKeys) => {
    if (Object.prototype.hasOwnProperty.call(r, key)) return r[key] === true
    if (legacy) return legacyKeys.some((k) => legacy.includes(k))
    return false
  }

  return {
    numero_marquage: boolFromNewOrLegacy("numero_marquage", ["numero_marquage"]),
    imei: boolFromNewOrLegacy("imei", ["imei"]),
    supplier_bill_number: boolFromNewOrLegacy("supplier_bill_number", ["supplier_bill_number", "bill_number"]),
    finaliser_plus_tard: r.finaliser_plus_tard === true,
    id_distributeur: boolFromNewOrLegacy("id_distributeur", ["id_distributeur"]),
    id_commande_distributeur: boolFromNewOrLegacy("id_commande_distributeur", ["id_commande_distributeur"])
  }
}
